const LOCALE_STORAGE_KEY = 'lang'

export default {
  methods: {
    async setLocale (lang) {
      if (!lang) {
        lang = await this.$storage.get({
          key: LOCALE_STORAGE_KEY
        }).then(({ value }) => value)
      }

      if (!lang) {
        const localLang = navigator.language || navigator.userLanguage
        if (localLang.match(/-/gi)) {
          lang = localLang.split(/-/gi)[0]
        } else {
          lang = localLang
        }
      }

      this.$i18n.locale = lang
      await this.$storage.set({
        key: LOCALE_STORAGE_KEY,
        value: lang
      })

      return lang
    }
  }
}
